module.exports = __webpack_public_path__ + "img/jiniantang1.001f9cf7.png";